import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { Form, ButtonGroup, ToggleButton } from 'react-bootstrap';

const ButtonGrouping = React.memo((props) => {
    // const getVariant = (val) => {
    //     const selected = props.formHandler.values[props.name] === val;
    //     return props.variant;
    //     if(!props.variant || props.variant == "light"){
    //         return "light";
    //     } else {
    //         return selected ? props.variant : "outline-" + props.variant;
    //     }
    // }
    return (
        <>
            <Form.Label className="btn-group-label">{props.label}</Form.Label>
            <ButtonGroup toggle className="custom-form-control"
                onBlur={props.formHandler.handleBlur}
                isInvalid={props.formHandler.touched[props.name] && props.formHandler.errors[props.name]}>
                {
                    props.options?.map((opt, idx) => (
                        <ToggleButton
                            key={idx}
                            type="radio"
                            size={props.size}
                            className={props.buttonClassName}
                            variant={props.variant}
                            name={props.name}
                            value={opt.value}
                            checked={props.formHandler.values[props.name] === opt.value}
                            //onChange={props.formHandler.handleChange}
                            onChange={v => {props.formHandler.setFieldValue(props.name, opt.value, true);}}>
                            {opt.name}
                        </ToggleButton>
                )
                )
            }
            </ButtonGroup>
            <Form.Control.Feedback type="invalid">{props.formHandler.errors[props.name]}</Form.Control.Feedback>
        </>
    );
})

export default ButtonGrouping;
